'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _draftJs = require('draft-js');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Updates the metadata for a given key.
 * If the metadata is null the key will be deleted from the metadata map.
 *
 * @param block {Object} The block to update metadata for.
 * @param metadata {Object} The data to store against the block key in the metadata map.  If null the key will be
 *          removed from the map.
 * @param editorState {Function} The function to retrieve the editor state.
 */
exports.default = function (editorState, block, metadata) {
    var blockKey = block.getKey();
    var contentState = editorState.getCurrentContent();
    var updatedBlock = contentState.getBlockForKey(blockKey).mergeIn(['data'], metadata);

    var blockMap = contentState.getBlockMap();
    blockMap = blockMap.merge(_defineProperty({}, blockKey, updatedBlock));
    contentState = contentState.merge({ blockMap: blockMap });

    // TODO use a constant for the change description
    return _draftJs.EditorState.push(editorState, contentState, 'change-block-metadata');
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/customRichUtils/updateBlockMetadata.js
// module id = 680
// module chunks = 0